export const getErrorsFiltered = (errors: (string | undefined)[]): string[] =>
  errors.filter((error): error is string => error !== undefined);
